/* motion: states */
import './states.css';

// Boot placeholder: card-shaped blocks, same box model as .game-card so nothing jumps.
export function skeletonHtml(count = 3): string {
  const card = `<div class="skeleton-card" aria-hidden="true">
    <span class="skeleton-bar skeleton-bar--head"></span>
    <span class="skeleton-bar skeleton-bar--row"></span>
    <span class="skeleton-bar skeleton-bar--row"></span>
  </div>`;
  return `<div class="skeleton-list" role="status" aria-live="polite" aria-label="Loading week">${card.repeat(count)}<span class="visually-hidden">Loading week…</span></div>`;
}

const FLASH = 'is-flash';
const PULSE = 'is-pulse';

function replay(el: Element, cls: string): void {
  el.classList.remove(cls);
  void (el as HTMLElement).offsetWidth;
  el.classList.add(cls);
  el.addEventListener('animationend', () => el.classList.remove(cls), { once: true });
}

function closestOf(node: Node, sel: string): Element | null {
  const el = node.nodeType === 1 ? (node as Element) : node.parentElement;
  return el ? el.closest(sel) : null;
}

// Animate lock badges that appear, and live scores whose text changes, after the first paint.
export function init(root: HTMLElement): void {
  if (typeof MutationObserver === 'undefined') return;
  const seen = new WeakSet<Element>();
  let baselined = false;
  const reduced = (): boolean =>
    typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;

  new MutationObserver((records) => {
    // The first real content (not the skeleton) is the baseline and never animates.
    if (!baselined) {
      if (root.querySelector('.skeleton-list') || !root.firstElementChild) return;
      root.querySelectorAll('.lock-badge').forEach((b) => seen.add(b));
      baselined = true;
      return;
    }
    if (reduced()) return;
    for (const r of records) {
      if (r.type === 'characterData') {
        const score = closestOf(r.target, '.live-score');
        if (score && r.oldValue !== r.target.nodeValue) replay(score, FLASH);
        continue;
      }
      r.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        const el = n as Element;
        const badges = el.matches('.lock-badge') ? [el] : [...el.querySelectorAll('.lock-badge')];
        for (const b of badges) {
          if (seen.has(b)) continue;
          seen.add(b);
          replay(b, PULSE);
        }
      });
    }
  }).observe(root, { subtree: true, childList: true, characterData: true, characterDataOldValue: true });
}
